import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button } from "react-bootstrap";
import Swal from "sweetalert2";

const AssessmentType = () => {

    const [assessTypeList, setAssessTypeList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [assessTypeName, setAssessTypeName] = useState("");
    const [assessTypeId, setAssessTypeId] = useState("");
    const [assessTypeDescription, setAssessTypeDescription] = useState("");
    const [assessTypeStatus, setAssessTypeStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchAssessType() {
            setIsLoading(true);
            const assessTypResponse = await func.assessmentType(null);
            setAssessTypeList(Array.isArray(assessTypResponse) ? assessTypResponse : [])
            setIsLoading(false);
        }
        fetchAssessType();
    }, [])

    const filteredData = assessTypeList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const assessTypNameRender = (rowData) => {
        return <span>{rowData.assessmentType} </span>;
    };

    const assessTypDescRender = (rowData) => {
        return <span>{rowData.assessmentTypeDescription} </span>;
    };

    const assessTypeStatusRender = (rowData) => {
        return <span>{(rowData.assessmentTypeStatus == 1) ? "Active" : "Inactive"
        }</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editAssessType(rowData)}>
                <i className="feather-edit" > </i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const assessId = rowData.assessmentTypeId;
        return (
            <Link to="#" onClick={() => deleteAssessType(assessId)}>
                <i className="feather-trash" > </i>Delete
            </Link>
        );
    };

    async function newAssessType() {
        setIsEdit(false)
        setOpenModal(true)
        setAssessTypeName("");
        setAssessTypeDescription("");
        setAssessTypeValue("");
    }


    async function editAssessType(rowData) {
        const assessId = rowData.assessmentTypeId;
        setIsEdit(true)
        setOpenModal(true)
        const getDetails = await func.assessmentType(assessId);
        setAssessTypeId(getDetails.assessmentTypeId);
        setAssessTypeName(getDetails.assessmentType);
        setAssessTypeDescription(getDetails.assessmentTypeDescription);
        setAssessTypeStatus(getDetails.assessmentTypeStatus);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateAssessType();
            } else {
                if (assessTypeName && assessTypeDescription) {
                    const formData = new FormData();
                    formData.append("assessmentType", assessTypeName);
                    formData.append("assessmentTypeDescription", assessTypeDescription);

                    const createAssessTyp = api.AssessmentType;
                    fetch(createAssessTyp, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Created',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }
            }
        }
    }

    function updateAssessType() {
        const formData = new FormData();
        formData.append("assessmentType", assessTypeName);
        formData.append("assessmentTypeDescription", assessTypeDescription);
        formData.append("status", assessTypeStatus);

        const updateAssessTyp = api.AssessmentType + '/' + assessTypeId;
        fetch(updateAssessTyp, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteAssessType(assessId: string) {
        const deleteAssessTyp = api.AssessmentType + '/' + assessId + '/' + 0;
        fetch(deleteAssessTyp, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader" >
                    <div className="loader-img" >
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row" >
                    <div className="sortby-section" >
                        <div className="sorting-info" >
                            <div className="row align-items-center" >
                                <div className="col d-flex justify-content-between" >
                                    <h4>Assessment Type </h4>
                                    {
                                        currentPermissions.includes("add") ?
                                            <Link
                                                to="#"
                                                className="btn"
                                                onClick={() => { newAssessType() }}
                                                data-bs-toggle="tooltip"
                                                style={{ fontSize: "24px", padding: "0px" }}
                                                title="Create Assessment Type" >
                                                <i className="feather-plus" />&nbsp;
                                            </Link>
                                            : null
                                    }
                                </div>
                            </div>
                            < div className="row col-lg-12 mb-10" >
                                <div className="col-lg-12 text-end dataTables_filter" >
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            < div className="tab-content" >
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble" >
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            > </Column>
                                            < Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="assessmentType"
                                                header="Assessment Type"
                                                body={assessTypNameRender}
                                                className="table-inset-btn"
                                            > </Column>
                                            < Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="assessmentTypeDescription"
                                                header="Assessment Type Description"
                                                body={assessTypDescRender}
                                                className="table-inset-btn"
                                            > </Column>
                                            < Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="assessmentTypeStatus"
                                                header="Assessment Type Status"
                                                body={assessTypeStatusRender}
                                                className="table-inset-btn"
                                            > </Column>
                                            {
                                                currentPermissions.includes("edit") ?
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    > </Column>
                                                    : null
                                            }
                                            {
                                                currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    > </Column>
                                                    : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered >
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case" > {isEdit ? "Edit " : "Add "} Assessment Type </h4>
                            </ModalTitle>
                            < Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)
                                }
                            > </Button>
                        </ModalHeader>
                        < ModalBody >
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10" >
                                    <div className="input-space" >
                                        <label className="form-label" > Assessment Type </label>
                                        < input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="assessmentTypName"
                                            value={assessTypeName}
                                            onChange={(e) => setAssessTypeName(e.target.value)}
                                            placeholder="Assessment Type Name" />
                                    </div>
                                </div>
                                < div className="col-lg-12 mb-10" >
                                    <div className="input-space" >
                                        <label className="form-label" > Assessment Type Description </label>
                                        < input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="assessmentTypDesc"
                                            value={assessTypeDescription}
                                            onChange={(e) => setAssessTypeDescription(e.target.value)}
                                            placeholder="Assessment type Description" />
                                    </div>
                                </div>
                                {
                                    isEdit ?
                                        <>
                                            <div className="row" >
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }
                                                }>
                                                    <label className="form-label" > Status </label>
                                                </div>
                                                < div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <div className="form-check form-switch d-flex align-items-center justify-content-end" >
                                                        <input
                                                            className="form-check-input text-end"
                                                            type="checkbox"
                                                            checked={assessTypeStatus === '1'}
                                                            id="status"
                                                            onChange={(e) => {
                                                                setAssessTypeStatus(e.target.checked ? '1' : '0')
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" /> Save </b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default AssessmentType;